import React from "react"
import Button from "./Button"
import buttonPropTypes from "./buttonPropTypes"

const IconButton = ({
  className,
  icon,
  onClick,
  background,
  color,
  text,
  ariaLabel,
  ref = undefined,
  ...rest
}) => (
  <Button
    className={className}
    ref={ref}
    background={background}
    text={text}
    color={color}
    icon={icon}
    onClick={onClick}
    ariaLabel={ariaLabel}
    {...rest}
  />
)

IconButton.displayName = "IconButton"

IconButton.propTypes = buttonPropTypes

export default IconButton
